"use client";

import { useReportWebVitals } from "next/web-vitals";

/**
 * P2-15 · Client web-vitals hook — beacons Core Web Vitals to the
 * first-party intake (`/api/observability/vitals`), which attaches brand
 * context and writes the structured `web-vital` log lines P9's dashboards
 * read. Renders nothing; mounted once in the storefront layout.
 */
const REPORTED = new Set(["LCP", "CLS", "INP", "FCP", "TTFB"]);

// Module-level (stable identity): next's useReportWebVitals re-registers the
// web-vitals listeners whenever the callback changes, which would double
// every beacon if a re-render handed it a fresh closure.
function reportMetric(metric: {
  name: string;
  value: number;
  rating?: string;
  id: string;
}) {
  if (!REPORTED.has(metric.name)) return;
  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    path: window.location.pathname,
  });
  // sendBeacon survives page unload (INP/CLS often finalise there); fall
  // back to fetch keepalive where beacons are unavailable.
  if (!navigator.sendBeacon?.("/api/observability/vitals", body)) {
    void fetch("/api/observability/vitals", {
      method: "POST",
      body,
      keepalive: true,
    }).catch(() => undefined);
  }
}

export function WebVitalsReporter() {
  useReportWebVitals(reportMetric);
  return null;
}
